export default __webpack_public_path__ + "media/images/payments/apple-pay-2858af7a61aa2d25ed28b37f501a1f7e.svg";